import styled from 'styled-components'
import Colors from '../../../../themes/Colors'

const AdsSectionHeaderHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  /* Breadcrumb styled as the section title ("Mis anuncios" › folder › …) */
  .ads-breadcrumb {
    font-family: 'Roboto', sans-serif;
    line-height: 32px;
    min-width: 0;

    .ant-breadcrumb-separator {
      color: ${Colors.textMuted};
      margin: 0 12px;
    }

    /* Root item ("Mis anuncios") */
    .bc-root {
      font-size: 24px;
    }

    /* Folder items */
    .bc-folder {
      font-size: 18px;
    }

    /* Root + ancestors: clickable, lighter weight */
    .bc-link {
      cursor: pointer;
      color: ${Colors.textMuted};
      font-weight: 500;

      &:hover {
        color: ${Colors.primaryAccent};
      }
    }

    /* Selected (current) folder: bold, dark, not clickable */
    .bc-current {
      color: ${Colors.textStrong};
      font-weight: bold;
    }

    /* Collapsed-middle marker: clickable, opens a popover with the hidden folders */
    .bc-ellipsis {
      color: ${Colors.textMuted};
      cursor: pointer;
      letter-spacing: 1px;

      &:hover {
        color: ${Colors.primaryAccent};
      }
    }
  }

  .actions {
    display: flex;
    gap: 8px;
    flex-shrink: 0;

    /* Icon sits before the label inside each button. */
    .btn-label {
      margin-left: 8px;
    }
  }

  /* Tablet and below (< lg): collapse the action buttons to icons only. */
  @media (max-width: 991px) {
    .actions .btn-label {
      display: none;
    }

    .actions .ant-btn .anticon {
      margin-left: 0;
    }
  }
`

export default AdsSectionHeaderHolder
